import { makeStyles, tokens } from '@fluentui/react-components';
export var useActionMenuIconStyles = makeStyles({
    iconContainer: {
        alignItems: 'center',
        display: 'flex',
        width: '20px',
        height: '100%',
    },
    urlIconSize: {
        width: '20px',
        height: '20px',
    },
    icon: {
        backgroundColor: tokens.colorTransparentBackground,
        color: tokens.colorNeutralForeground2,
        ':hover': {
            backgroundColor: tokens.colorTransparentBackground,
            color: tokens.colorNeutralForeground2BrandPressed,
        },
    },
    disabledIcon: {
        backgroundColor: tokens.colorTransparentBackground,
        color: tokens.colorNeutralForegroundDisabled,
    },
});
//# sourceMappingURL=ActionMenuIcon.styles.js.map